// The annotation CSS plus the Source Serif 4 webfont it and chat bot messages use. The font loads
// from JS rather than a CSS @import so it goes through our first-party font proxy (ENG-35583).
import { loadGoogleFont } from '~/common/helpers/font'
import './text_annotation_component.css'

loadGoogleFont(
  'Source Serif 4:ital,opsz,wght@0,8..60,200..900;1,8..60,200..900'
)
